import styled from 'styled-components';
import { VehicleEngineType } from '~/shared';

const StyledContainer = styled.div<{ $engineType: VehicleEngineType }>`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: ${(props) =>
		props.$engineType === VehicleEngineType.Petrol ? '200px' : '120px'};
	height: 40px;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	padding: 0 20px;

	p {
		font-family: 'GT Walsheim Pro';
		font-style: normal;
		font-weight: 500;
		font-size: 16px;
		line-height: 18px;
		color: #ffffff;
		user-select: none;
		pointer-events: none;
	}
`;

export { StyledContainer };
